<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="addProduct" style="margin-top:20px">新增</el-button>
        <el-button size="medium" type="primary" plain @click="exportProduct" style="margin-top:20px">导出</el-button>
        <el-button size="medium" @click="importProduct" style="margin-top:20px">导入</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form :model="searchForm" ref="searchForm" :inline="true" style="margin-top:20px">
          <el-form-item label="可入库产品名称：">
            <el-input size="medium" v-model="searchForm.orderProductName"></el-input>
          </el-form-item>
          <el-form-item label="可入库产品代码：">
            <el-input size="medium" v-model="searchForm.orderProductCode"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="querySearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="可入库产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="可入库产品名称" prop="PRODUCT_NAME"></el-table-column>
          <el-table-column label="可入库产品单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button type="text" @click="deleteProduct(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 导入价格 -->
    <el-dialog title="导入" center :visible.sync="exportFormVisible" width="500px">
      <el-form ref="exportForm" v-model="exportForm" style="margin-left: 30px">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess" :on-remove="handleRemove"
          :name="this.exportForm.price" multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <p @click="downLoadTmp">点击下载模板</p>
          <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
        </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeImport('exportForm')">取 消</el-button>
        <el-button @click="submitEnter('exportForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog title="新增" center :visible.sync="addFormVisible" width="500px">
      <el-form ref="addForm" v-model="addForm" label-width="150px">
        <el-form-item label="可入库产品编码：">
          <el-input v-model="addForm.PRODUCT_CODE"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button @click="submitAddProduct()">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount"
          @current-change="handleCurrentChange"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      // loading: false,
      // 导入
      exportForm: {
        price: 'tmp',
      },
      fileList: [],
      exportFormVisible: false,
      url: '',
      name: '',
      nowPrice: '',
      tableData: [],
      kindsId: sessionStorage.getItem('kindId'),
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      searchForm: {},
      PRODUCT_NAME: '',
      TYPE_UNIT: '',
      // 新增
      addFormVisible: false,
      addForm: {},
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
  },
  methods: {
    // 导入
    importProduct() {
      this.exportFormVisible = true;
    },
    closeImport(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
      this.fileList = [];
    },
    handleSuccess(response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.url = '';
    },
    submitEnter() {
      if (!this.url) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '20002',
            OTYPE: 5,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
            FILE_NAME: this.url,
          };
          http.post(params)
            .then((result) => {
              this.$message.show({ text: '导入成功', type: 'success' });
              this.url = '';
              this.exportFormVisible = false;
              this.fileList = [];
              this.$refs.upload.clearFiles();
              this.queryTable();
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              this.url = '';
              this.$refs.upload.clearFiles();
              document.body.style.cursor = 'default';
            });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    // 导入模板下载
    downLoadTmp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/SupplierProductsInWarehouse.xls';
    },
    // 导出
    exportProduct() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '20002',
            OTYPE: 4,
            USER_ID: sessionStorage.getItem('userId'),
            SESSION: sessionStorage.getItem('session'),
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          };
          http.post(params).then((res) => {
            window.location.href = res[0].FILE_PATH;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // 新增
    addProduct() {
      this.addFormVisible = true;
    },
    // 新增模态框的确认
    submitAddProduct() {
      const reg = /^\d+$/;
      if (!reg.test(this.addForm.PRODUCT_CODE)) {
        this.$message.show({ text: '请输入正确的产品编码', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '20002',
        OTYPE: 1,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PRODUCT_CODE: this.addForm.PRODUCT_CODE,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addFormVisible = false;
        this.queryTable();
        this.addForm.PRODUCT_CODE = '';
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拉取可入库产品列表
    queryTable() {
      const params = {
        SERVICE_ID: '20002',
        OTYPE: 3,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.orderProductCode) {
        params.PRODUCT_CODE = this.searchForm.orderProductCode;
      }
      if (this.searchForm.orderProductName) {
        params.PRODUCT_NAME = this.searchForm.orderProductName;
      }
      http.post(params).then((res) => {
        if (res.length === 0) {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else {
          this.tableData = res[0].list;
          this.totalCount = res[0].TOTAL_COUNT;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 筛选
    querySearch() {
      this.currentPage = 1;
      this.queryTable();
    },
    // 解除绑定
    deleteProduct(row) {
      this.$confirm('您确认要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '20002',
          OTYPE: 2,
          USER_ID: sessionStorage.getItem('userId'),
          SESSION: sessionStorage.getItem('session'),
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          RELEATION_ID: row.ID,
        };
        http.post(params).then((result) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.queryTable();
          document.body.style.cursor = 'default';
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          document.body.style.cursor = 'default';
        });
      }).catch(() => {
        // this.$message.show({
        //     text:'取消操作',
        //     type: 'warning'
        // });
      });
    },
    // 分页
    handleCurrentChange() {
      this.queryTable();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SKUManage/canInput.vue